"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formFiledModule = _interopRequireDefault(require("../styles/form-filed.module.css"));

var _baseModule = _interopRequireDefault(require("../styles/base.module.css"));

var _btn_google_light_normal_ios = _interopRequireDefault(require("../imgs/btn_google_light_normal_ios.svg"));

var _Loader = require("./Loader");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var GoogleButton = function GoogleButton(_ref) {
  var onClick = _ref.onClick,
      disabled = _ref.disabled,
      type = _ref.type,
      isProcessing = _ref.isProcessing;
  return _react.default.createElement("button", {
    onClick: onClick,
    disabled: disabled,
    className: "".concat(_formFiledModule.default.button, " ").concat(_baseModule.default.googleButton)
  }, _react.default.createElement("span", {
    style: {
      backgroundImage: "url(".concat(_btn_google_light_normal_ios.default, ")")
    }
  }), _react.default.createElement("span", null, isProcessing ? _react.default.createElement(_Loader.ButtonLoader, {
    color: "#484848"
  }) : "".concat(type === 'login' ? 'Login' : 'Continue', " with Google")));
};

var _default = GoogleButton;
exports.default = _default;